import { useModals } from '@mantine/modals';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

const useDuplicateContactModal = () => {
  const modals = useModals();
  const currentAssetId = useCurrentAssetId();
  const { t } = useTranslation();

  const openModal = useCallback(
    (contactId: string) =>
      modals.openContextModal('duplicateContactModal', {
        innerProps: { contactId, currentAssetId },
        title: t('contacts.duplicateModal.title', "Dupliquez le contact dans d'autres biens"),
      }),
    [currentAssetId, modals, t]
  );

  return openModal;
};

export default useDuplicateContactModal;
